/* eslint-disable quote-props */
export default {
  translation: {
    'words.save': 'Ahorrar',
    'words.other': 'Otro',
    'header.previousUser': 'Volver a tu cuenta',
    'header.logout': 'Salir',
    'header.settings': 'Ajustes',
    'header.titleTest': 'prueba de cabecera',
    'header.yourProjects': 'Tus Proyectos',
    'header.createProject': 'Crear Proyecto',
    'header.createProject.tooltip': 'Los nuevos proyectos se utilizan para diferentes años y diferentes tipos de retornos o compromisos.',
    'header.signIn': 'Inicia Sesión',
    'settings.lang.es': 'Español',
    'settings.lang.en': 'Ingles',
    'settings.loading': 'Cargando',
    'settings.message.success': 'Guardado!',
    'settings.message.save': 'Guardar cambios',
    'settings.changePassword': 'Cambiar Contraseña',
    'settings.pass.currentPassword': 'Contraseña Actual',
    'settings.pass.newPassword': 'Nueva Contraseña',
    'settings.pass.confirmNewPassword': 'Confirmar Nueva Contraseña',
    'settings.pass.passwordMust': 'La contraseña debe tener al menos 8 caracteres.',
    'settings.changeLanguage': 'Cambiar Lenguaje',
    'settings.changeLanguage.error': 'Se produjo un error al cambiar el idioma',
    'settings.changeLanguage.success': 'Se ha cambiado el idioma satisfactoriamente',
    'settings.twoFactorAuthentication': 'Autenticación en 2 pasos',
    'settings.twofa.enable': 'Habilitar la autenticación en 2 pasos para añadir una capa de seguridad.',
    'settings.twofa.scan': 'Escanea este codigo con tu app.',
    'settings.twofa.getKey1': 'Si no puedes usar este codigo',
    'settings.twofa.getKey2': 'Consigue una llave',
    'settings.twofa.getKey3': 'para colocarla de forma manual.',
    'settings.twofa.enterCode': 'Introduce el codigo de 6 digitos de tu app.',
    'settings.twofa.saveChanges': 'Guardar cambios',
    'project.complete': 'Completo',
    'project.inProgress': 'En Progreso',
    'project.interview': 'Entrevista',
    'project.documents': 'Documentos',
    'project.invoices': 'Facturas',
    'project.yourOpenTasks': 'Tus Tareas Pendientes',
    'project.openTasks': 'Tareas Pendientes',
    'project.completedTasks': 'Tareas Completadas',
    'contactinfo.title': 'Información de contacto',
    'contactinfo.changeReview': 'Revisión de Cambios',
    'contactinfo.leaveReview': 'Dejar un Comentario',
    'contactinfo.yourRepresentative': 'Tu representante',
    'contactinfo.taxQuestions': 'Preguntas sobre impuestos',
    'contactinfo.yourReview': 'Tu revisión',
    'contactinfo.scheduleAnAppointment': 'Agendar una Cita',
    'referrals.title': 'Referir',
    'referrals.cta': 'Comparte tu enlace de referencia',
    'referrals.totalReferred': 'Total referido',
    'referrals.more': 'Más formas de compartir',
    'referrals.share': 'Compartir',
    'referrals.copy': 'Copiar',
    'referrals.copied': '¡Copiado!',
    'referrals.copyMessage': 'Copiar mensaje',
    'referrals.emailMessage': 'Mensaje de correo electrónico',
    'referrals.completed': 'Referencias completadas',
    'referrals.firstName': 'Primer nombre',
    'referrals.lastName': 'Apellido',
    'referrals.tooltip': 'Use su enlace único a continuación para referir clientes a la firma',
    'modal.addProject.taxYear': 'Año fiscal',
    'modal.addProject.selectTaxYear': 'Seleccionar año fiscal',
    'modal.addProject.projectType': 'Tipo de proyecto',
    'modal.addProject.selectProjectType': 'Seleccionar tipo de proyecto',
    'modal.addProject.close': 'Cerrar',
    'modal.addProject.create': 'Crear',
    'modal.addProject.required': 'Requerido',
    'modal.addProject.alreadyExistsError': 'Ya tienes un proyecto para este año y escribes en progreso. Úselo o elija un año/tipo diferente.',
    'modal.addReview.comments': 'Comentarios',
    'modal.addReview.charactersRemaining': 'Caracteres restantes',
    'modal.addReview.placeholder': 'Tu comentario',
    'modal.addReview.submitReview': 'Enviar comentario',
    'modal.addReview.updateReview': 'Actualizar revisión',
    'interview.modalTitle': 'Completa Entrevista',
    'interview.information': 'Complete cada sección a continuación para cambiar a luz verde y luego puede enviar.',
    'interview.submit': 'Enviar',
    'interview.back': 'Atras',
    'interview.markAsComplete': 'Marcar como completo',
    'interview.markAsNotComplete': 'Marcar como no completo',
    'interview.sectionHasPrepopulated': 'Parte de su información se completó previamente a partir de otras entrevistas. Por favor, confirma que los datos son correctos.',
    'interview.confirmBtnLabel': 'Confirmo',
    'interview.interviewSection.addDependent': 'Agregar dependiente',
    'interview.interviewSection.removeDependent': 'Eliminar último dependiente',
    'interview.interviewSection.saveAndContinue': 'Guardar & Continuar',
    'interview.interviewSection.loading': 'Cargando...',
    'interview.close': 'Cerrar',
    'interview.formfield.datepicker.placeholder': 'MM/DD/AAAA',
    'interview.formfield.dollars.placeholder': 'Solo cantidades en dólares',
    'interview.formfield.dependent_name_first': 'Nombre del Dependiente',
    'interview.formfield.dependent_name_last': 'Apellido del Dependiente',
    'interview.dependentSection.addDependent': 'Agregar dependiente',
    'interview.dependentSection.delete': 'Borrar',
    'interview.dependentSection.dependents': 'Dependientes',
    'interview.dependentSection.noDependents': 'No ha declarado ningún dependiente. Si necesita agregar algunos, haga clic en Agregar dependiente a continuación.',    
    'interview.dependentSection.maximumNumber': '¡Número máximo de secciones dependientes!',    
    'invoices.notAvailable': 'No hay facturas emitidas todavía.',
    'invoices.title': 'Facturas',
    'invoices.close': 'Cerrar',
    'invoices.payInvoice': 'Pagar Factura',
    'invoices.paid': 'Pagada',
    'invoices.requested': 'No pagado',
    'invoices.processing': 'Procesando',
    'invoices.canceled': 'Cancelado',
    'invoices.view': 'Ver',
    'invoices.payment.info': 'Al proporcionar la información de su tarjeta aquí, se le cobrará inmediatamente lo siguiente',
    'invoices.payment.description': 'Descripción',
    'invoices.payment.priceEach': 'Precio de cada uno',
    'invoices.payment.quantity': 'Cantidad',
    'invoices.payment.itemTotal': 'Total',
    'invoices.payment.totalCharge': 'Total a cobrar',
    'invoices.payment.totalCurrency': ' USD',
    'invoices.payment.payInvoice': 'Pagar Factura',
    'invoices.paymentForm.cardHolderName': 'Nombre del titular de la tarjeta',
    'invoices.paymentForm.cardNumber': 'Número de tarjeta',
    'invoices.paymentForm.expirationDate': 'Fecha de expiración',
    'invoices.paymentForm.payNow': 'Pagar ahora',
    'invoiceView.noItemsAvailable': 'No hay artículos disponibles',
    'invoiceView.description': 'Descripción',
    'invoiceView.pricePer': 'Precio por',
    'invoiceView.quantity': 'Cantidas',
    'invoiceView.itemTotal': 'Total',
    'dashboard.addProject.title': 'Agregar proyecto',
    'dashboard.addProject.success': 'El proyecto se ha agregado con éxito.',
    'dashboard.invoices.title': 'Facturas',
    'dashboard.documents.title': 'Documentos',
    'dashboard.addReview.title': 'Dejar un comentario',
    'documents.firm': 'La Firma',
    'documents.documentsFrom': 'Documentos de',
    'documents.documentsFrom.tooltip': 'Número de aprobaciones/firmas de documentos pendientes.',
    'documents.generalFirm': 'la Firma',
    'documents.yourDocuments': 'Sus documentos cargados',
    'documents.yourDocuments.tooltip': 'Número de solicitudes de documentos pendientes.',
    'documents.done': 'Hecho',
    'documents.clientDocuments.msgUpload': 'Suelta archivos o haz clic para subir',
    'documents.clientDocuments.msgLoading': 'Cargando...',
    'documents.clientDocuments.notFormat': 'No se pudo detectar el nombre del archivo seleccionado',
    'documents.clientDocuments.name': 'Nombre del documento',
    'documents.clientDocuments.pendingFileRequest': 'Solicitud pendiente: {{fileName}}',
    'documents.clientDocuments.fileNameIsEmpty': 'el nombre del archivo no fue proporcionado',
    'documents.clientDocuments.fileSize': 'Tamaño del archivo',
    'documents.clientDocuments.date': 'Fecha',
    'documents.clientDocuments.notUploaded': 'Aún no has subido ningún documento.',
    'documents.clientDocuments.whichDocUploaded': '¿Cuál de los siguientes documentos está cargando?',
    'documents.clientDocuments.whichDocTitle': 'Documentos cargados',
    'documents.clientDocuments.uploadSuccess': 'cargado exitosamente.',
    'documents.clientDocuments.view': 'Ver',
    'documents.clientDocuments.delete': 'Eliminar',
    'documents.clientDocuments.cancel': 'Cancelar',
    'documents.clientDocuments.deleteSuccess': 'Archivo eliminado con éxito',
    'documents.clientDocuments.areYouSure': 'Estas seguro',
    'documents.clientDocuments.deleteMessage': 'Está a punto de eliminar este archivo.',
    'documents.clientDocument.notAllowedType': 'El documento de este tipo no está permitido. Solo puede cargar textos, imágenes, hojas de cálculo y archivos PDF.',
    'documents.clientDocument.tooBig': 'El tamaño del archivo cargado supera el tamaño máximo de {{maxSizeMb}}MB. Intente subir un archivo diferente.',        
    'documents.firmDocuments.status': 'Estado',
    'documents.firmDocuments.description': 'Descripción',
    'documents.firmDocuments.requestedTime': 'Hora solicitada',
    'documents.firmDocuments.viewOriginal': 'Ver original',
    'documents.firmDocuments.notUploaded': 'La firma aún no ha subido ningún documento.',
    'documents.firmDocuments.complete': 'Completo',
    'documents.firmDocuments.sent': 'Expedido',
    'documents.firmDocuments.finalCopy': 'Descargar copia final',
    'documents.firmDocuments.approverName': 'Revisar como {{approverName}}',
    'upcomingAppointments.title': 'Tu próxima cita',
    'upcomingAppointments.type': 'Type',
    'upcomingAppointments.type.VIDEO': 'Video',
    'upcomingAppointments.type.CALL': 'Llamada',
    'upcomingAppointments.type.HOME': 'Casa',
    'upcomingAppointments.type.OFFICE': 'Oficina',
    'upcomingAppointments.type.OTHER': 'Otro lugar de servicio',
    'upcomingAppointments.status': 'Estatus',
    'upcomingAppointments.status.canceled': 'Cancelado',
    'upcomingAppointments.status.complete': 'Completo',
    'upcomingAppointments.status.confirmed': 'Confirmado',
    'upcomingAppointments.status.incomplete': 'Incompleto',
    'upcomingAppointments.status.rescheduled': 'Reagendado',
    'upcomingAppointments.status.scheduled': 'Agendado',
    'upcomingAppointments.starts': 'Comienza',
    'upcomingAppointments.ends': 'Termina',
    'upcomingAppointments.notes': 'Notas',
    'upcomingAppointments.join': 'Entrar',
    'upcomingAppointments.cancel': 'Cancelar',
    // others
    'Complete interview': 'Completar entrevista',
    'Upload documents': 'Subir documentos',
    'Upload document': 'Subir documento',
    'Thank you for your submitting, we will be in contact with you soon': 'Gracias por su envío, nos pondremos en contacto muy pronto.',
    'Saved': 'Guardado',
    'Payment was successful': 'El pago fue exitoso',
    'Your review successfully created': 'Tu reseña se creó correctamente',
    'Your review successfully updated': 'Tu reseña se actualizó correctamente',
    'You already have a job for this tax year in progress!': '¡Ya tiene un trabajo para este año fiscal en curso!',
    'Project was successfully created!': '¡El proyecto fue creado con éxito!',
    'Approve document': 'Aprobar documento',
    'Pay invoice': 'Pagar Factura',
    'Sign document': 'Firmar documento',
    // CHAT
    'scheduleCall.error': 'No hay más fechas disponibles para este día.',
    'scheduleCall.callScheduled': 'Llamada programada',
    'scheduleCall.schedule': 'Programar',
    'scheduleCall.selectOption': 'Seleccione una opción',
    'scheduleCall.duration': 'Duración',
    'scheduleCall.date': 'Fecha',
    'scheduleCall.next': 'Siguiente',
    'scheduleCall.skipNotes': 'Saltar notas',
    'scheduleCall.notes': 'Notas',
    'scheduleCall.scheduleCall': 'Programar llamada',
    'scheduleCall.noEventTypes': 'Su preparador no tiene horarios disponibles para programar.',
    'chat.ChannelNotSetup': 'El canal actual no está configurado',
    'chat.downloadFile.error': 'Este archivo está dañado o se ha eliminado',
    'chat.incomingCall.accept': 'Aceptar',
    'chat.incomingCall.decline': 'Rechazar',
    'chat.incomingCall.title': 'Llamada Entrante',
    'chat.chatInput.fileUploaded': 'cargado exitosamente.',
    'chat.chatInput.fileNotUploaded': 'falló al cargar.',
    'chat.chatInput.selectProject': 'Seleccione un proyecto para cargar un archivo.',
    'chat.chatInput.sendMessage': 'Enviar Mensaje',
    'chat.userActive': 'Activo Ahora',
    'chat.messagesList.missedCall': 'Llamada rechazada',
    'videocall.call.meetingWith': 'Reunión con',
    'videocall.call.callScheduledFor': 'Esta llamada está programada para {{date}} a las {{timeH}}:{{timeM}} puedes acceder hasta ese momento.',
    'call.callErrors.description.cleanMeeting': 'Por favor, elija su configuración de audio y video.',
    'call.callErrors.title.userNotInvited': 'Usuario no invitado a la llamada',
    'call.callErrors.description.userNotInvited': 'No estás invitado a esta llamada.',
    'call.callErrors.title.mustLogin': 'El usuario no ha iniciado sesión',
    'call.callErrors.description.mustLogin': 'Inicie sesión para ingresar a esta llamada.',
    'call.callErrors.title.earlierAccess': 'Esta llamada aún no está disponible',
    'call.callErrors.title.laterAccess': 'Esta llamada ha terminado',
    'call.callErrors.description.laterAccess': 'Aún puedes acceder a los mensajes de chat.',
    'call.callErrors.title.callCancelled': 'Esta videollamada fue cancelada',
    'call.callErrors.description.callCancelled': 'Esta videollamada fue cancelada por uno o más de los participantes.',
    'call.callErrors.title.noCam': 'Permiso de cámara denegado',
    'call.callErrors.description.noCam': 'No ha concedido ni bloqueado el acceso a la cámara. Actualice la configuración de su navegador para permitir el acceso.',
    'call.callErrors.title.noMic': 'Permiso de micrófono denegado',
    'call.callErrors.description.noMic': 'No ha concedido ni bloqueado el acceso al micrófono. Actualice la configuración de su navegador para permitir el acceso.',
    'call.callErrors.title.callExpired': 'Esta llamada ya venció',
    'call.callErrors.description.callExpired': 'Si cree que se trata de un error, comuníquese con su preparador de impuestos.',
    'call.join': 'Únete ahora',
    'videocall.me': 'Yo',
    'videocall.callMenu.recordSession': 'Grabar Sesión',
    'videocall.callMenu.stopRecording': 'Dejar de Grabar',
    'Invite.title': 'Registrarse a {{- preparerName}} para preparar tus impuestos',
    'Invite.title.defaultPreparerName': 'our client portal',
    'Invite.titleInstructions': 'Ingrese los detalles requeridos para comenzar',
    'Invite.titleSecure': 'Bienvenido a nuestro portal seguro',
    'Invite.create.error': 'Ocurrió un error al crear la cuenta.',
    'Invite.twoFactorCode.empty': 'Introduce el codigo de 6 digitos de tu app.',
    'Invite.side.alreadyClient': '¿Ya eres cliente?',
    'Invite.side.message1': 'Bienvenido a nuestra plataforma fácil de usar, diseñada para un intercambio de información fluido y seguro con nuestra firma. Prepárese para experimentar nuestra experiencia de cliente moderna que mantiene todo en su lugar con un solo inicio de sesión.',
    'Invite.side.message2': 'Una vez que se registre, puede iniciar sesión en el portal en cualquier momento utilizando su dirección de correo electrónico. Enlace a la pantalla de inicio de sesión de',
    'Invite.side.messageLink': '“iniciar sesión en el portal”',
    'Invite.side.message3': '.',
    'Invite.form.alert.msg1': 'Una cuenta con esa dirección de correo electrónico ya está registrada con nosotros',
    'Invite.form.alert.msg2': '¿Necesitas',
    'Invite.form.alert.password': 'La contraseña es demasiado débil.',
    'Invite.form.alert.link': 'Restablecer su contraseña',
    'Invite.form.alert.expired': 'Este enlace ha caducado. Comuníquese con su preparador de impuestos para obtener uno nuevo.',
    'InviteForm.placeholder.email': 'ejemplo@ejemplo.com',
    'InviteForm.language': 'Lenguaje',
    'InviteForm.taxFilingFor': '¿Para qué sera la declaración de impuestos?',
    'InviteForm.taxYearFor': '¿Para qué año fiscal sera esto?',
    'InviteForm.email': 'Correo',
    'InviteForm.firstName': 'Nombre',
    'InviteForm.lastName': 'Apellido',
    'InviteForm.landLine': 'Teléfono Fijo',
    'InviteForm.mobileNumber': 'Número de teléfono móvil',
    'InviteForm.workNumber': 'Número de trabajo',
    'InviteForm.createPassword': 'Crear contraseña',
    'InviteForm.confirmPassword': 'Confirmar contraseña',
    'InviteForm.passwordsNotMatch': 'Las contraseñas no coinciden',
    'InviteForm.twoFactor': 'Autenticación en 2 pasos',
    'InviteForm.termsAndConditions': 'Acepto los',
    'InviteForm.termsAndConditionsLink': 'Terminos de Uso',
    'InviteForm.getStarted': 'Comenzar',
    'InviteForm.required': '¡Requerido!',
    'InviteForm.fixErrors': 'Corrija los errores anteriores.',
    'InviteForm.success': '¡Cuenta creada con éxito!',
    'InviteForm.birthday': 'Fecha de Nacimiento',
    'ChatInput.uploadTitle': '¿Quieres subir y enviar este archivo?',
    'taskType.DOCUMENTS': 'Sube tu primer documento',
    'taskType.INTERVIEW': 'Completa tu entrevista',
    'taskType.PAYMENTS': 'Hacer el pago',
    'taskType.REQUEST_DOCUMENTS': 'Subir documento',
    'taskType.SIGNATURES': 'Subir firma',
    'taskType.APPROVE_DOCUMENTS': 'Aprobar firma',
    'datepicker.placeholder': 'Seleccione fecha',
  },
  emojiMart: {
    search: 'Buscar',
    clear: 'Limpiar', // Accessible label on "clear" button
    notfound: 'No se encontró ningún emoji',
    skintext: 'Elija su tono de piel predeterminado',
    categories: {
      search: 'Resultados de la búsqueda',
      recent: 'Usados frecuentemente',
      smileys: 'Emoticonos y emoción',
      people: 'Personas y cuerpo',
      nature: 'Animales y naturaleza',
      foods: 'Comida y bebida',
      activity: 'Actividad',
      places: 'Viajes y lugares',
      objects: 'Objectos',
      symbols: 'Simbolos',
      flags: 'Banderas',
      custom: 'Personalizado',
    },
    categorieslabel: 'Categorías de emoji', // Accessible title for the list of categories
    skintones: {
      1: 'Default Skin Tone',
      2: 'Light Skin Tone',
      3: 'Medium-Light Skin Tone',
      4: 'Medium Skin Tone',
      5: 'Medium-Dark Skin Tone',
      6: 'Dark Skin Tone',
    },
  },
  countryList: {
    US: 'Estados Unidos', AF: 'Afghanistan', AX: '\u00c5land Islands', AL: 'Albania', DZ: 'Algeria', AS: 'American Samoa', AD: 'Andorra', AO: 'Angola', AI: 'Anguilla', AQ: 'Antarctica', AG: 'Antigua & Barbuda', AR: 'Argentina', AM: 'Armenia', AW: 'Aruba', AC: 'Ascension Island', AU: 'Australia', AT: 'Austria', AZ: 'Azerbaijan', BS: 'Bahamas', BH: 'Bahrain', BD: 'Bangladesh', BB: 'Barbados', BY: 'Belarus', BE: 'Belgium', BZ: 'Belize', BJ: 'Benin', BM: 'Bermuda', BT: 'Bhutan', BO: 'Bolivia', BA: 'Bosnia & Herzegovina', BW: 'Botswana', BR: 'Brazil', IO: 'British Indian Ocean Territory', VG: 'British Virgin Islands', BN: 'Brunei', BG: 'Bulgaria', BF: 'Burkina Faso', BI: 'Burundi', KH: 'Cambodia', CM: 'Cameroon', CA: 'Canada', IC: 'Canary Islands', CV: 'Cape Verde', BQ: 'Caribbean Netherlands', KY: 'Cayman Islands', CF: 'Central African Republic', EA: 'Ceuta & Melilla', TD: 'Chad', CL: 'Chile', CN: 'China', CX: 'Christmas Island', CC: 'Cocos (Keeling) Islands', CO: 'Colombia', KM: 'Comoros', CG: 'Congo - Brazzaville', CD: 'Congo - Kinshasa', CK: 'Cook Islands', CR: 'Costa Rica', CI: 'C\u00f4te d\u2019Ivoire', HR: 'Croatia', CU: 'Cuba', CW: 'Cura\u00e7ao', CY: 'Cyprus', CZ: 'Czech Republic', DK: 'Denmark', DG: 'Diego Garcia', DJ: 'Djibouti', DM: 'Dominica', DO: 'Dominican Republic', EC: 'Ecuador', EG: 'Egypt', SV: 'El Salvador', GQ: 'Equatorial Guinea', ER: 'Eritrea', EE: 'Estonia', ET: 'Ethiopia', FK: 'Falkland Islands', FO: 'Faroe Islands', FJ: 'Fiji', FI: 'Finland', FR: 'France', GF: 'French Guiana', PF: 'French Polynesia', TF: 'French Southern Territories', GA: 'Gabon', GM: 'Gambia', GE: 'Georgia', DE: 'Germany', GH: 'Ghana', GI: 'Gibraltar', GR: 'Greece', GL: 'Greenland', GD: 'Grenada', GP: 'Guadeloupe', GU: 'Guam', GT: 'Guatemala', GG: 'Guernsey', GN: 'Guinea', GW: 'Guinea-Bissau', GY: 'Guyana', HT: 'Haiti', HN: 'Honduras', HK: 'Hong Kong SAR China', HU: 'Hungary', IS: 'Iceland', IN: 'India', ID: 'Indonesia', IR: 'Iran', IQ: 'Iraq', IE: 'Ireland', IM: 'Isle of Man', IL: 'Israel', IT: 'Italy', JM: 'Jamaica', JP: 'Japan', JE: 'Jersey', JO: 'Jordan', KZ: 'Kazakhstan', KE: 'Kenya', KI: 'Kiribati', XK: 'Kosovo', KW: 'Kuwait', KG: 'Kyrgyzstan', LA: 'Laos', LV: 'Latvia', LB: 'Lebanon', LS: 'Lesotho', LR: 'Liberia', LY: 'Libya', LI: 'Liechtenstein', LT: 'Lithuania', LU: 'Luxembourg', MO: 'Macau SAR China', MK: 'Macedonia', MG: 'Madagascar', MW: 'Malawi', MY: 'Malaysia', MV: 'Maldives', ML: 'Mali', MT: 'Malta', MH: 'Marshall Islands', MQ: 'Martinique', MR: 'Mauritania', MU: 'Mauritius', YT: 'Mayotte', MX: 'Mexico', FM: 'Micronesia', MD: 'Moldova', MC: 'Monaco', MN: 'Mongolia', ME: 'Montenegro', MS: 'Montserrat', MA: 'Morocco', MZ: 'Mozambique', MM: 'Myanmar (Burma)', NA: 'Namibia', NR: 'Nauru', NP: 'Nepal', NL: 'Netherlands', NC: 'New Caledonia', NZ: 'New Zealand', NI: 'Nicaragua', NE: 'Niger', NG: 'Nigeria', NU: 'Niue', NF: 'Norfolk Island', KP: 'North Korea', MP: 'Northern Mariana Islands', NO: 'Norway', OM: 'Oman', PK: 'Pakistan', PW: 'Palau', PS: 'Palestinian Territories', PA: 'Panama', PG: 'Papua New Guinea', PY: 'Paraguay', PE: 'Peru', PH: 'Philippines', PN: 'Pitcairn Islands', PL: 'Poland', PT: 'Portugal', PR: 'Puerto Rico', QA: 'Qatar', RE: 'R\u00e9union', RO: 'Romania', RU: 'Russia', RW: 'Rwanda', WS: 'Samoa', SM: 'San Marino', ST: 'S\u00e3o Tom\u00e9 & Pr\u00edncipe', SA: 'Saudi Arabia', SN: 'Senegal', RS: 'Serbia', SC: 'Seychelles', SL: 'Sierra Leone', SG: 'Singapore', SX: 'Sint Maarten', SK: 'Slovakia', SI: 'Slovenia', SB: 'Solomon Islands', SO: 'Somalia', ZA: 'South Africa', GS: 'South Georgia & South Sandwich Islands', KR: 'South Korea', SS: 'South Sudan', ES: 'Spain', LK: 'Sri Lanka', BL: 'St. Barth\u00e9lemy', SH: 'St. Helena', KN: 'St. Kitts & Nevis', LC: 'St. Lucia', MF: 'St. Martin', PM: 'St. Pierre & Miquelon', VC: 'St. Vincent & Grenadines', SD: 'Sudan', SR: 'Suriname', SJ: 'Svalbard & Jan Mayen', SZ: 'Swaziland', SE: 'Sweden', CH: 'Switzerland', SY: 'Syria', TW: 'Taiwan', TJ: 'Tajikistan', TZ: 'Tanzania', TH: 'Thailand', TL: 'Timor-Leste', TG: 'Togo', TK: 'Tokelau', TO: 'Tonga', TT: 'Trinidad & Tobago', TA: 'Tristan da Cunha', TN: 'Tunisia', TR: 'Turkey', TM: 'Turkmenistan', TC: 'Turks & Caicos Islands', TV: 'Tuvalu', UM: 'U.S. Outlying Islands', VI: 'U.S. Virgin Islands', UG: 'Uganda', UA: 'Ukraine', AE: 'United Arab Emirates', GB: 'United Kingdom', UY: 'Uruguay', UZ: 'Uzbekistan', VU: 'Vanuatu', VA: 'Vatican City', VE: 'Venezuela', VN: 'Vietnam', WF: 'Wallis & Futuna', EH: 'Western Sahara', YE: 'Yemen', ZM: 'Zambia', ZW: 'Zimbabwe',
  },
  AddressConfig: [
    {
      fieldType: 'text',
      label: 'Dirección Linea 1',
      subName: '_address1',
      required: true,
    },
    {
      fieldType: 'text',
      label: 'Dirección Linea 2',
      subName: '_address2',
      required: false,
    },
    {
      fieldType: 'text',
      label: 'Ciudad',
      subName: '_city',
      required: true,
    },
    {
      fieldType: 'text',
      label: 'Estado/Provincia/Region',
      subName: '_state',
      required: true,
    },
    {
      fieldType: 'text',
      label: 'ZIP/Codigo Postal',
      subName: '_zip',
      required: true,
    },
    {
      fieldType: 'dropdown',
      label: 'País',
      subName: '_country',
      required: true,
    },
  ],
  yup: {
    required: 'Requerido',
    invalidEmail: 'Correo invalido',
    phoneNumber: 'El número no es válido',
    passwordToShort: 'El password debe tener minimo 8 caracteres',
    passwordToLong: 'El password debe tener máximo 30 caracteres',
    passwordToWeak: 'La contraseña es demasiado débil.',
  },
};
